<template>
  <v-container fluid fill-height pa-0 ma-0>
    <v-row no-gutters justify="center" align="stretch" class="fill-height">
      <!-- Map Section (Optional) -->
      <v-col v-if="isLoading" cols="12">
        <v-row justify="center">
          <v-col cols="12">
            <v-skeleton-loader type="image" />
          </v-col>
          <v-col cols="3">
            <v-skeleton-loader type="sentences@4" class="mb-5" />
            <v-skeleton-loader type="paragraph@2" />
          </v-col>
          <v-col cols="3">
            <v-skeleton-loader type="image,actions" />
          </v-col>
        </v-row>
      </v-col>

      <!-- Info Section -->
      <v-col v-if="!isLoading" cols="12">
        <InfoSection :datas="datas" />
      </v-col>
    </v-row>
    <IntercomCustomers v-if="datas" :datas="datas" />
  </v-container>
</template>

<script>
import { InfoSection } from "./components";

const trackPurchaseOnce = (orderData) => {
  if (!orderData || window.__gtmPurchaseTracked) return;
  // Required fields check
  console.log("Tracking purchase:");
  if (!orderData.totalAmount || !orderData.orderRef) return;
  const eventKey = `gtmPurchaseTracked_${orderData.orderRef}`;
  if (sessionStorage.getItem(eventKey)) {
    console.log("Purchase already tracked for this order.");
    return;
  }
  console.log("Tracking purchase for order:", orderData.orderRef);
  sessionStorage.setItem(eventKey, "true");
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "purchase",
    transactionValue: orderData.totalAmount,
    transactionId: orderData.orderRef,
    currency: orderData.currency || "DKK",
  });

  window.__gtmPurchaseTracked = true;
};

export default {
  layout: "Public",
  name: "Thanks",
  components: { InfoSection },
  props: {
    propOrderRef: {
      type: String,
      required: true,
    },
  },
  async beforeRouteEnter(to, from, next) {
    const { data } = await axios.get(
      "/app/orders/cart/checkout/" + to.params.orderref
    );

    next((vm) => {
      vm.datas = data.data;
      vm.orderref = to.params.orderref;
      setTimeout(() => {
        vm.isLoading = false;
      }, 500);
      console.log("Thanks.vue data:", data.data);
      trackPurchaseOnce(data.data);
    });
  },
  data: () => ({
    isLoading: true,
    datas: null,
    orderref: null,
  }),
  created() {
    // fetchOderDetails is handled in beforeRouteEnter
    // this.fetchOderDetails();
  },
  beforeMount() {
    const self = this;
    self.$store.dispatch("guest/removeInfo");
    self.$store.dispatch("delivery/removeDeliveryDetails");
    self.$store.dispatch("delivery/removeDeliveryMethod");
    self.$store.dispatch("guest/removeAddress");
    self.$store.dispatch("guest/removeSessionId");
    self.$store.dispatch("checkout/setTotal", 0);
    self.$store.dispatch("cart/deleteDetails");
    self.$store.dispatch("customer/removeOption");
    self.$store.dispatch("delivery/setOptionDoor", false);
  },
  methods: {
    async fetchOderDetails() {
      if (this?.orderref) {
        const { data } = await axios.get(
          "/app/orders/cart/checkout/" + this.orderref
        );
        this.datas = data.data;
        console.log("Thanks.vue data:", data.data);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.v-container {
  background-color: #f5f5f5;
}
</style>
